import React from 'react';
import { pendingDoneStatusOptions } from '../../../constants/patient';
import IntakeFormRow from '../IntakeFormRow';
import IntakeToggleGroup from '../IntakeToggleGroup';

type Value = 'pending' | 'done' | '';

type Props = {
  label: string;
  value: Value;
  onChange: (value: Value) => void;
};

/** 未 / 済 の2択（未選択可） */
const PendingDoneRadioGroup: React.FC<Props> = ({ label, value, onChange }) => (
  <IntakeFormRow label={label}>
    <IntakeToggleGroup
      options={pendingDoneStatusOptions}
      value={value}
      onChange={(v) => onChange(v as Value)}
      ariaLabel={label}
    />
  </IntakeFormRow>
);

export default PendingDoneRadioGroup;
